import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type CancelDeletionRequest = {
    token: string
}

type CancelDeletionSuccessResponse = {
    status: number
};

type CancelDeletionErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type CancelDeletionResponse = CancelDeletionSuccessResponse | CancelDeletionErrorResponse;


export function cancelDeletion(token: string): Promise<CancelDeletionResponse> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<CancelDeletionResponse, CancelDeletionRequest>(
            HubApiMethods.CANCEL_REMOVE_ACCOUNT,
            { token },
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.cancelRemoveAccount(window.app.deviceIdentifier, { token });
    }
}
